import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseEvents } from '../data/product';
const MINUTES = [2, 4, 6, 7, 9, 11, 13, 16];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = window.setTimeout(() => {
      setVisible(true);
      timeout = window.setTimeout(() => setVisible(false), 5200);
    }, 4500);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(timeout);
    };
  }, [index, dismissed]);
  useEffect(() => {
    if (dismissed) return;
    if (visible) return;
    const next = window.setTimeout(() => setIndex(i => (i + 1) % purchaseEvents.length), 3800);
    return () => window.clearTimeout(next);
  }, [visible, dismissed]);
  const event = purchaseEvents[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-148" data-mp="1z52qct8mlrri">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[248px] max-w-[calc(100vw-24px)] rounded-lg border-2 border-volt bg-navy p-2.5 shadow-2xl sm:w-[288px]" role="status" aria-live="polite" data-id="element-149" data-mp="1z7ox4qnp038o">
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1 top-1 rounded p-0.5 text-white/60 transition-colors duration-150 hover:text-white" data-id="element-150" data-mp="1kfwiyhzmwv8j">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-151" data-mp="wqlotjcshz3d" />
          </button>
          <div className="flex items-start gap-2" data-id="element-152" data-mp="20216v92w5xla">
            <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-volt" aria-hidden="true" data-id="element-153" data-mp="200gd3loeiioh" />
            <div className="min-w-0" data-id="element-154" data-mp="1v13oavdyz1j9">
              <p className="font-head text-[13px] font-bold uppercase leading-tight tracking-wide text-volt" data-id="element-155" data-mp="28ul1lyg2bi0u">
                {event.name} just purchased
              </p>
              <p className="truncate text-[11px] font-semibold leading-tight text-white" data-id="element-156" data-mp="1h2vngcdtbg2t">
                {event.city}
              </p>
              <p className="text-[10px] font-medium leading-tight text-white/60" data-id="element-157" data-mp="1c53tlctlxjvz">
                {minutes} minutes ago
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}